// TopLosersWidget.tsx
import React from 'react';
import styled from 'styled-components';
import { createCompanySlug } from '@/src/utils/helpers';
import { CardContentHolder, CardWrapper, CustomWidgetHeader, DataTable } from './style';

interface GainerLoserItem {
  code: number;
  name: string;
  logo: string;
  price: number;
  changePercent: number;
  volume: number;
  priceChange: number;
}

const TopLosersWidget: React.FC<{ data: GainerLoserItem[] }> = ({ data }) => {
  return (
    <CardContentHolder placing={true}>
        <CardWrapper>
      <div className="card-main">
        <CustomWidgetHeader>
          <h2>Top Losers</h2>
          <a href="/share-market-today/nse-top-losers" className="links-btn">
            View All
          </a>
        </CustomWidgetHeader>
        <DataTable>
          <tbody>
            {data.map((item) => (
              <tr key={item.code}>
                <td>
                  <a href={`/stocks/${createCompanySlug(item.name)}-share-price`}>{item.name}</a>
                </td>
                <td>
                  <p className="price-value">₹{item.price?.toFixed(2)}</p>
                  <p className={`${item.priceChange <= 0 ? 'negative' : ''}`}>
                    {item.priceChange?.toFixed(2)}<span>({item.changePercent?.toFixed(2)}%)</span>
                  </p>
                </td>
              </tr>
            ))}
          </tbody>
        </DataTable>
      </div>
    </CardWrapper>
    </CardContentHolder>
  );
};

export default TopLosersWidget;
